import React from 'react';
import { useRouter } from '../../components';
import { SiteLink } from '../../components';
//import BottomDrawer from '../../components/bottomDrawer'

export function BottomDock(props) {
  const links = [
    // { url: '/dare-chisel', title: 'DARE CHISEL', icon: 'dare-chisel.png', iconHover: 'dare-chisel.png' },
    // { url: '/about', title: 'ABOUT', icon: 'about.png', iconHover: 'about.png' },
    // { url: '/products', title: 'PRODUCTS', icon: 'products.png', iconHover: 'products.png' },
    // { url: '/services', title: 'SERVICES', icon: 'services.png', iconHover: 'services.png' },
    // { url: '/contact', title: 'CONTACT', icon: 'contact.png', iconHover: 'contact.png' }
    { url: '/about', title: 'DARE', icon: 'dare-icon.png', iconHover: 'dare-icon.png' },
    { url: '/shop', title: 'SHOP', icon: 'shop-icon.png', iconHover: 'shop-icon.png' },
    { url: '/cart', title: 'CART', icon: 'cart-icon.png', iconHover: 'cart-icon.png' },
    { url: '/services', title: 'SERVICES', icon: 'services-icon.png', iconHover: 'services-icon.png' },
    { url: '/contact', title: 'CONTACT', icon: 'contact-icon.png', iconHover: 'contact-icon.png' }
  ];

  //const path = usePath();
  const { pathname } = useRouter();

  const isCurrent = (link) => {
    return pathname && pathname.toLowerCase() === link.toLowerCase();
  }

  const linkElts = links.map((link, index) =>
    <li key={index} className={`bottomMenu__li ${isCurrent(link.url) ? 'selected' : ''}`}>
      <SiteLink to={link.url} className={`bottomMenu__link bottomMenu__link--${index}`}>
        <div className="icon">
          <img className="normal" src={`/assets/navicons/${link.icon}`} alt={link.title} />
          <img className="selected" src={`/assets/navicons/${link.iconHover}`} alt={link.title} />
        </div>
        <div>{link.title}</div>
      </SiteLink>
    </li>
  );

  // const bottomMenu = useRef(null);
  // useLayoutEffect(() => {
  //   //console.log('useLayoutEffect');
  //   const slider = new BottomDrawer(bottomMenu.current);
  //   setTimeout(() => slider.init(), 1000)
  // }, [])

  return (
    <>
      <nav className="bottomMenu">
        {/* <div className="bottomMenu__bar">
          <div className="bottomMenu__line1"></div>
          <div className="bottomMenu__line2"></div>
        </div> */}
        {/* <div className="bottomMenu__bg"></div> */}
        <ul className="bottomMenu__links">
          {linkElts}
        </ul>
      </nav>
      {/* <div className="bottomMenuPadding"></div> */}
    </>
  );
}
